import { gql, useQuery } from '@apollo/client'
import { ForbiddenError } from '../components/ErrorBoundary'
import { StructParams, StructureBase, getChildType, QueryStructParams, VDCounts } from '../lib/structures'
import { useEffect } from 'react'

export interface StructureSummary extends StructureWithSummaryData {
  parents: StructureBase[]
  children: StructureWithSummaryData[]
}

interface StructureWithSummaryData extends StructureBase {
  registration: {
    rollAll: number
    rollSheet: number
    milestone: number
    target: number
  }
  canvassing: {
    current: number
    milestone: number
    target: number
  }
  microtargeting: {
    phase1: {
      current: number
      target: number
    }
  }
  counts: VDCounts
}

interface StructureReturns {
  stats: StructureSummary | undefined
  loading: boolean
}

interface SummaryResult {
  structure: StructureSummary
}

const query = gql`
query getSummaryData($type: String!, $code: String!, $childType: String!, $filterLabel: String) {
  structure(type: $type, code: $code, filterLabel: $filterLabel) {
    type
    code
    name
    responsiblePersons { firstname surname displayname }
    userHasAccess
    structureHasAssignedWards
    counts {
      total
      filtered
    }
    registration {
      rollAll
      rollSheet
      milestone
      target
    }
    canvassing {
      current
      milestone
      target
    }
    microtargeting {
      phase1 {
        current
        target
      }
    }    
    parents { type code name userHasAccess }
    children(type: $childType) {
      type
      code
      name
    responsiblePersons { firstname surname displayname }
      userHasAccess
      structureHasAssignedWards
    counts {
      total
      filtered
    }
    registration {
      rollAll
      rollSheet
      milestone
      target
    }
    canvassing {
      current
      milestone
      target
    }
    microtargeting {
      phase1 {
        current
        target
      }
    }      
    }
  }
}
`

export default function useSummaryData ({ type, code, filterLabel }: StructParams): StructureReturns {
  const childType = getChildType({ type, code })
  const { error, data, refetch, loading } = useQuery<SummaryResult, QueryStructParams>(
    query,
    { variables: { type, code, childType, filterLabel }, notifyOnNetworkStatusChange: true }
  )

  useEffect(() => {
    refetch()
  }, [filterLabel, refetch])

  if (error?.graphQLErrors[0]?.extensions?.code === 'FORBIDDEN') {
    throw new ForbiddenError('this structure')
  }
  if (error != null) throw error

  return { stats: data?.structure, loading: loading }
}
